export default __webpack_public_path__ + "static/media/vivo.1d1d5f50.jpg";